var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-chip",
    {
      staticClass: "mx-1 my-1 font-weight-bold black--text",
      attrs: { color: "cyan lighten-4" }
    },
    [
      _c(
        "v-avatar",
        { attrs: { left: "", color: "cyan darken-4" } },
        [
          _c("v-icon", { attrs: { color: "white", size: "18" } }, [
            _vm._v("cci-rank-1")
          ])
        ],
        1
      ),
      _vm._v("\n  " + _vm._s(_vm.name) + "\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }